import { useMutation } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import type { FrontEndLog } from '../types/types'

export const useSystemLog = () => {
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (log: FrontEndLog) => {
      await authFetch().POST('/system/log', { body: log })
    }
  })
}
